import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import KnowledgeAreasServices from "./KnowledgeAreas.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getKnowledgeAreas = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: true,
    });
    const resp = await KnowledgeAreasServices.getKnowledgeAreas(filters);
    dispatch({
      type: actions.GET_KNOWLEDGE_AREAS,
      payload: {
        knowledgeAreas: resp.data.data,
        knowledgeAreasLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.KNOWLEDGE_AREAS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.KNOWLEDGE_AREAS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: false,
    });
  }
};

export const getKnowledgeAreasById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: true,
    });
    const resp = await KnowledgeAreasServices.getKnowledgeAreasById(id);
    dispatch({
      type: actions.GET_KNOWLEDGE_AREAS,
      payload: {
        knowledgeArea: resp.data
      },
    });
    dispatch({
      type: actions.KNOWLEDGE_AREAS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.KNOWLEDGE_AREAS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: false,
    });
  }
};

export const saveKnowledgeAreas = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_KNOWLEDGE_AREAS,
      payload: true,
    });
    const resp = await KnowledgeAreasServices.saveKnowledgeAreas(data);
    const { knowledgeAreas, knowledgeAreasLength } = getState().knowledgeAreas;
    const _knowledgeAreas = [...knowledgeAreas, resp.data];
    dispatch({
      type: actions.GET_KNOWLEDGE_AREAS,
      payload: {
        knowledgeAreas: _knowledgeAreas,
        knowledgeAreasLength: knowledgeAreasLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: {},
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_KNOWLEDGE_AREAS,
      payload: false,
    });
  }
};

export const editKnowledgeAreas = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: true,
    });
    const resp = await KnowledgeAreasServices.editKnowledgeAreas(id, data);
    const { knowledgeAreas, knowledgeAreasLength } = getState().knowledgeAreas;
    knowledgeAreas[index] = resp.data;
    dispatch({
      type: actions.GET_KNOWLEDGE_AREAS,
      payload: {
        knowledgeAreas: knowledgeAreas,
        knowledgeAreasLength: knowledgeAreasLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: {},
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: false,
    });
  }
};

export const deleteKnowledgeAreas = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: true,
    });
    await KnowledgeAreasServices.deleteKnowledgeAreas(id);
    const { knowledgeAreas, knowledgeAreasLength } = getState().knowledgeAreas;
    knowledgeAreas.splice(index, 1);
    dispatch({
      type: actions.GET_KNOWLEDGE_AREAS,
      payload: {
        knowledgeAreas: knowledgeAreas,
        knowledgeAreasLength: knowledgeAreasLength - 1,
      },
    });
    dispatch({
      type: actions.KNOWLEDGE_AREAS_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.KNOWLEDGE_AREAS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_KNOWLEDGE_AREAS,
      payload: false,
    });
  }
};
